import { Component, input } from '@angular/core';

import { ExternalLink } from '../../interfaces/external-link.interface';

@Component({
  selector: 'fin-external-link',
  templateUrl: './external-link.component.html',
  standalone: false,
})
export class ExternalLinkComponent {
  link = input.required<ExternalLink>();
}
